import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { debounce } from "lodash";
import {
  Breadcrumb,
  Input,
  Table,
  Space,
  Popconfirm,
  Col,
  Row,
  Tooltip,
} from "antd";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";

const { Search } = Input;

const ArchivedVendorDocumentStape = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const vendorAdmin = authUserData()?.vendor
    ? authUserData()?.role[0].name
    : null;
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [archiveVendorDocument, setArchiveVendorDocument] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getVendorOnboardingArchiveList = async () => {
      setLoading(true);
      let apiResponse;
      try {
        // if (vendorAdmin === "Vendor Admin") {
        //   apiResponse = await getRequest(
        //     `vendor-document-restore/?vendor_id=${VendorId}`,
        //     state
        //   );
        // }
        //  else {
        // apiResponse = await getRequest(
        //   `vendor-document/list-archive-document/?company_id=${CompanyId}&vendor_id=${
        //     id ? id : VendorId
        //   }`,
        //   state
        // );
        const apiResponse = await getRequest(
          `vendor-document/list-archive-document/?${
            CompanyId && `company_id=${CompanyId}`
          }&vendor_id=${id ? id : VendorId}`,
          state
        );

        // }

        if (apiResponse.data.results.success) {
          setArchiveVendorDocument(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archivelist"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getVendorOnboardingArchiveList();
  }, [state, t, reload]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "document_name" && sortOrder === "ascend") {
      sortingEnumKey = "document_name";
    }
    if (sortField === "document_name" && sortOrder === "descend") {
      sortingEnumKey = "-document_name";
    }
    if (sortField === "document_url" && sortOrder === "ascend") {
      sortingEnumKey = "document_url";
    }
    if (sortField === "document_url" && sortOrder === "descend") {
      sortingEnumKey = "-document_url";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("vendor-document/document-restore/", {
        deleted: ids,
      });

      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("document_restore_successfully"));
        setSelectedRow([]);
        setReload(!reload);
        // navigate("/vendor");
      } else {
        ErrorNotificationMsg(t("error_in_restore_document"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "document_name",
      key: "document_name",
      sorter: true,
    },
    {
      title: "Document",
      dataIndex: "document_url",
      key: "document_url",
      sorter: true,
      render: (document_url) =>
        document_url && (
          <>
            <a
              style={{ textDecoration: "none", color: "black" }}
              href={`${document_url}`}
              download
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={document_url}
                style={{ width: "50px", height: "50px" }}
                alt=""
              />
            </a>
          </>
        ),
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore
              className="ArchiverestorImg"
              style={{ cursor: "pointer" }}
            />{" "}
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("archived_vendor_document")}</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {vendorAdmin === "Vendor Admin" ? (
                  <Link to="/my-vendor">{t("My Company")}</Link>
                ) : (
                  <Link to="/vendor">{t("vendorOnboarding")}</Link>
                )}
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archive")} </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            <Row className="tblheader">
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                className="tbl-action"
              >
                {selectedRow.length > 0 && (
                  <Popconfirm
                    className="action"
                    title={t("pop_restore_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleRestore()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label="Restore"
                    />
                  </Popconfirm>
                )}
              </Col>
            </Row>
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archiveVendorDocument}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() => navigate(`/vendor`)}
              //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchivedVendorDocumentStape;
